
import Vue from "vue"
import { mapGetters } from "vuex"
import FooterBase from "~/components/base/footerBase"
import { GET_USER } from "~/store/auth/getters"

export default Vue.extend({
  name: "TheFooter",
  extends: FooterBase,
  computed: {
    ...mapGetters("auth", {
      user: GET_USER
    })
  }
  // TODO Tracking should be added to click on PhoneNumber
})
